import "../../../styles/components/home/banners/homeBannerCardComponent.scss";

export const HomeBannerCardComponent = ({ props }) => {
  const { image } = props;

  return (
    <div className="homePageBannerCardContainer" style={{ backgroundImage: `url(${image})` }}>
      <div className="overlay"></div>
    </div>
  );
};

export default HomeBannerCardComponent;
